import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { LogsResponse, LogsQueryParams } from "@/models/logs";
import { ILogsApi } from "./ILogsApi";

@injectable()
export class LogsApi implements ILogsApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/logs";

  async getLogs(params: LogsQueryParams): Promise<LogsResponse> {
    const { data } = await this.client.post<LogsResponse>(this.baseUrl, {
      query: params.query
    });
    return data;
  }
}
